<template>
    <div>
    <div id="detail" class="grid-container full container">
      <!-- <app-message v-if="submitted === true" enquiryNumber="messageModel" /> -->

      <div class="grid-container">
        <div class="grid-x grid-padding-x">
          <div class="cell">
            <h3>
              My Enquiries
            </h3>
            <p v-if="isAuthenticated && orders.length>0">
              {{ orders.length }}&nbsp;{{ orders.length===1?'Enquiry':'Enquiries' }}.
            </p>
          </div>

          <div
            v-if="isAuthenticated"
            class="product-details product-detail-photos cell"
          >

<table class="">
  <thead style="background: #e6e6e6 !important;">
    <tr>
      <th >No.</th>
      <th >Enquiry placed</th>
      <th>Items</th>
      <th >Total</th>
      <th >Status</th>
      <th ></th>
    </tr>
  </thead>
  <tbody class="details-description">
    <tr v-for="(item, index) in orders" :key="index">
      <td>
        <span class="font-bold"><!-- {{item.serialNumber}} -->
          {{item.remarksParsed ? item.remarksParsed : item.serialNumber}}
        </span>
      </td>
      <td>{{(new Date(item.createdOn)).toDateString()}}</td>
      <td>{{item.itemCount}}</td>
      <td>{{(item.discountTotal || 0).toFixed(2)}} USD</td>
      <td>
        <span class="font-bold">
          {{item.orderStateFk===1?'Submitted':
            item.orderStateFk===2?'Processing':
            item.orderStateFk===3?'Finished':
            item.orderStateFk===4?'Canceled':''
          }}
          </span>
      </td>
      <td>
         <router-link 
            :to="{name:'orderDetail', params:{ orderId: item.id }}"
            class="button small  hollow radius" style="margin:0;">
            Order Details
          </router-link>
      </td>
    </tr>
    
  </tbody>
</table>

            <!-- <div v-for="(item, index) in orders"
                  :key="index"
                  class="details-description grid-x grid-padding-y">



            </div> -->
          </div>

          <div v-if="!isAuthenticated" class="cell">
            <div class="grid-x grid-padding-x container">
              <div class="cell large-6 text-center">
                <h3 class="font-bold">
                  Got an account?
                </h3>
                <p class="padding-bottom-1">
                  We saved your cart to your account. <br />
                  Simply login to retreive your cart items.
                </p>
                <router-link
                  :to="{ name: 'login' }"
                  class="text-uppercase button radius large"
                >
                  Account login
                </router-link>
              </div>
              <div class="cell large-6 text-center">
                <h3 class="font-bold">
                  Guest Customer?
                </h3>
                <p class="padding-bottom-1">
                  Did you start shopping on a different device? <br />
                  Create an account to access your cart on all your devices.
                </p>
                <router-link
                  :to="{ name: 'register' }"
                  class="text-uppercase button radius secondary large"
                >
                  Create an account
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Needs to Login Or Register Message-->
    <div class="reveal" id="exampleModal1" data-reveal>
      <h1>Submit Almost Done</h1>
      <p class="lead">
        Your are not signed in yet.
      </p>
      <p>
        Please
        <router-link :to="{ name: 'login' }" style="" data-close>
          Sign In
        </router-link>
        Or
        <span>Or</span>
        <router-link :to="{ name: 'register' }" style="" data-close>
          Register
        </router-link>
      </p>
      <button
        class="close-button"
        data-close
        aria-label="Close modal"
        type="button"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <button
      ref="modal"
      class="button"
      data-open="exampleModal1"
      style="visibility:hidden;opacity:0;"
    ></button>

    <!--Space-->
    <div class="container"></div>
  </div>
</template>

<script>
    import orderDataService from "@/store.order/services/main-service.js";
    import userInfoService from "@/app.user/services/main-service.js";
    import configService from "@/app/config-service.js";

    export default {
        name: "userOrders",
        data() {
            return {
                userInfo: {},

                loading: false,
                errored: false,
                orders: [],
                orderDetails:[]
            };
        },
        computed:{
            baseUrl(){
                return configService.baseUrl;
            },
            fullName() {
            return this.userInfo.lastName
                ? this.userInfo.lastName + " " + this.userInfo.firstName
                : null;
            },
            isAuthenticated() {
              //TODO-VICTOR: CHECK For token or key?
              return this.fullName !== null;
            },
        },
        created() {
            this.getOrders();

            let _this = this;
            _this.userInfo = userInfoService.getCurrentUserInfo();
        },
        methods: {
            async getOrders() {
                let userInfo = userInfoService.getCurrentUserInfo();
                if(userInfo && userInfo.id){
                    try {
                        this.loading = true;
                        const {data} = await orderDataService.getOrdersByUser(userInfo.id);
                        data.forEach((item)=>{
                          item.remarksParsed = item.userDefinedTitle ? JSON.parse(item.userDefinedTitle) : ''  
                        });

                        this.orders = data.reverse();
                    } catch (error) {
                        this.errored = true;
                        console.error(error);
                    } finally {
                        this.loading = false;
                    }
                }
            },
            async showDetails(orderId){
                if(orderId){
                    try {
                        this.loading = true;
                        const {data} = await orderDataService.getOrderDetails(orderId);
                        this.orderDetails = data;
                    } catch (error) {
                        this.errored = true;
                        console.error(error);
                    } finally {
                        this.loading = false;
                    }
                }
            }
        },
    };
</script>

<style lang="scss">
@import "./../../assets/sass/settings/settings";

.catalog-title::before {
  content: "";
}

img {
  max-width: 100%;
  width: auto \9;
  height: auto;
  vertical-align: middle;
  border: 0;
  -ms-interpolation-mode: bicubic;
}

#owl-demo .item img {
  display: block;
  width: 100%;
  height: auto;
}

.btns {
  display: table;
  margin: 30px auto;
}

.customNextBtn,
.customPreviousBtn {
  float: right;
  background: #2d9070;
  color: #fff;
  padding: 10px;
  margin-left: 5px;
  cursor: pointer;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.small-photos {
  .cell {
    padding-bottom: 1rem;
  }
}

.product-details {
  .details-header {
    font-size: 13px;
  }
  .details-description {
    font-size: 13px;
    p {
      font-size: 13px;
    }
  }
}
</style>

<style lang="scss" scoped>
